// Progress numbers for the client portal. The public portal receives them
// already computed by the backend (it never gets tasks outside the
// client-visible statuses); the internal preview computes the same shape here.
export const DONE_STATUS = 'done';

export const computePortalStats = (tasks) => {
  const stats = { totalTasks: 0, completedTasks: 0, byEpic: {}, bySprint: {} };
  const add = (bucket, key, done) => {
    if (key === null || key === undefined) return;
    bucket[key] ??= { total: 0, completed: 0 };
    bucket[key].total += 1;
    if (done) bucket[key].completed += 1;
  };

  for (const task of tasks) {
    const done = task.status === DONE_STATUS;
    stats.totalTasks += 1;
    if (done) stats.completedTasks += 1;
    add(stats.byEpic, task.epicId, done);
    add(stats.bySprint, task.sprintId, done);
  }

  return stats;
};

export const EMPTY_PORTAL_STATS = { totalTasks: 0, completedTasks: 0, byEpic: {}, bySprint: {} };

// Percentage (0-100) for a { total, completed } bucket; 0 when it is missing
export const progressOf = (bucket) =>
  bucket && bucket.total > 0 ? (bucket.completed / bucket.total) * 100 : 0;
